module.exports = __webpack_public_path__ + "static/media/upload.f07bb293.svg";